import dayjs from 'dayjs';
import { GridCustomCellProps } from "@progress/kendo-react-grid";

const LocalDateOnlyCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;
  const date = props.dataItem[props.field];
  return (
    <td {...props.tdProps}>
      {date ? dayjs(date).format("MM/DD/YYYY") : "N/A"}
    </td>
  );
}

export default LocalDateOnlyCell;
